export const priceRound = (
  value: number,
  digit: number | undefined = 4
): number => {
  const _digit = 10 ** (Math.trunc(value).toString().length - digit)
  return Math.round(value / _digit) * _digit
}
